import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * On route changes, scroll back to top (unless URL contains an anchor hash —
 * in which case smooth-scroll to that target).
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
}
